export default () => ({
  authorization: {},
});
